module.exports = "<div class=\"gray-bg\">\n\n  <div class=\"wrapper wrapper-content animated fadeInRight\">\n  demo-component works!\n  </div>\n</div>\n<app-view-time-component></app-view-time-component>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modules/development/demo-component/demo-component.component.html
// module id = ./src/app/shared/modules/development/demo-component/demo-component.component.html
// module chunks = main